import { log } from 'log';
import { useEffect } from 'react';
import { useUserSelector, useCustomSelector } from 'js/store/hooks';
import { path, prop } from 'js/utils/ramda.util';
import { useSelector, useDispatch } from 'react-redux';
import { SPORTSBOOK_REDUCER, USER_REDUCER } from 'js/store/constants';

import * as actions from '../store/actions';

export const useSportsbookBalance = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const balances = useCustomSelector(USER_REDUCER, (state) => state.balance?.balances);

    useEffect(() => {
        if (isAppInitialized && isLoggedIn) {
            try {
                window.Sportsbook?.sendMessage('GET_BALANCE').then((response) => dispatch(actions.updateBalances(response)));
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Get balance error', error);
            }
        }
    }, [dispatch, isAppInitialized, isLoggedIn]);

    useEffect(() => {
        if (isAppInitialized && isLoggedIn && balances) {
            try {
                const balanceMessage = {
                    ID: 32010,
                    data: {
                        balances: []
                    }
                };

                for (const balanceType in balances) {
                    balanceMessage.data.balances.push({
                        balanceType,
                        balance: balances[balanceType]
                    });
                }
                window.Sportsbook?.sendMessage('OAPI_RESPONSE', balanceMessage);
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Set balance error', error);
            }
        }
    }, [balances, dispatch, isAppInitialized, isLoggedIn]);
};
